import { useEffect, useState } from "react"
import type { SelectOptionType, SuccessFetch } from "../../../../../../../../types"
import { useApi } from "../../../../../../../../utils"

export function useProvince(county_id?: string) {
  const api = useApi()
  const [data, setData] = useState<SelectOptionType[] & { country_id?: string }[]>([])
  const [isLoading, setLoading] = useState(false)

  const params: { [key: string]: number | string | undefined } = {};
  if (county_id) params.county_id = county_id;

  const refetch = (county_id?: string) => {
    setLoading(true)

    api.get("/provinces/", {
      params: { county_id: county_id }
    }).then((res: SuccessFetch<{
      payload: {
        country_id?: string
        province_id: string
        province_name: string
      }[]
    }>) => {
      setData(res.data.payload.map(item => {
        return {
          label: item.province_name,
          value: item.province_id,
          country_id: item.country_id
        }
      }))
    }).catch(() => {
      setData([])
    }).finally(() => {
      setLoading(false)
    })
  }

  useEffect(() => {
    api.get("/provinces/", { params }).then((res: SuccessFetch<{
      payload: {
        country_id?: string
        province_id: string
        province_name: string
      }[]
    }>) => {
      setData(res.data.payload.map(item => {
        return {
          label: item.province_name,
          value: item.province_id,
          country_id: item.country_id
        }
      }))
    }).catch(() => {
      setData([])
    }).finally(() => {
      setLoading(false)
    })
  
    return () => {
      setData([])
      setLoading(true)
    }

    // eslint-disable-next-line
  }, [])

  return { data, isLoading, refetch }
}